<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex xs8>
                <v-card>
                    <v-layout row justify-space-between>
                        <v-layout column class="ma-1 px-3">
                            <v-card-title class="pb-1 pt-3" primary-title>
                                <div>
                                    <div v-if="account.nonUTA">
                                        <v-layout
                                            row
                                            align-center
                                            class="pl-2 py-2"
                                        >
                                            <h3 class="headline my-0">
                                                Account ID:
                                                {{ account.accountID }}
                                            </h3>
                                            <div
                                                class="font-weight-medium ml-2 text-info"
                                            >
                                                Non UTA
                                            </div>
                                            <v-card-actions>
                                                <v-btn
                                                    small
                                                    @click="editAccount"
                                                    >Edit Account</v-btn
                                                >
                                            </v-card-actions>
                                        </v-layout>
                                    </div>
                                    <h3
                                        class="headline my-0"
                                        v-if="!account.nonUTA"
                                    >
                                        Account ID:
                                        {{ account.accountID }}
                                    </h3>
                                </div>
                            </v-card-title>
                            <v-card-text class="mb-0 pb-0">
                                <h4 class="card-title font-weight-medium">
                                    {{ account.name }}
                                </h4>
                                <p>
                                    {{ account.hname }}
                                </p>
                                <p>
                                    {{ account.address1 }}
                                </p>
                                <br />
                                <div class="ml-2 mt-2">
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Home:
                                        </div>
                                        <div>
                                            {{ account.homePhone }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Cell:
                                        </div>
                                        <div>
                                            {{ account.cellPhone }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Email:
                                        </div>
                                        <div>
                                            {{ account.emailAddress }}
                                        </div>
                                    </v-layout>
                                </div>
                            </v-card-text>

                            <v-card-actions class="pl-2 pt-3">
                                <v-layout row wrap>
                                    <div v-if="!editingInfo" class="pl-2 mt-0">
                                        <v-layout
                                            row
                                            align-center
                                            class=" mb-3"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Transportation:
                                            </div>
                                            <div>
                                                {{ info.transportation }}
                                            </div>
                                            <v-btn
                                                @click="() => editInfo()"
                                                flat
                                                icon
                                                class="text-xs-right"
                                                color="success"
                                            >
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </div>
                                    <div v-else>
                                        <!-- <v-text-field
                                            class="mb-3"
                                            hide-details
                                            label="Transportation"
                                            v-model="info.transportation"
                                        ></v-text-field> -->
                                        <v-combobox
                                            class="mb-3"
                                            autocomplete="new-password"
                                            hide-details
                                            :items="transportationList"
                                            label="Transportation"
                                            v-model="info.transportation"
                                        ></v-combobox>
                                        <v-layout row class="mb-3">
                                            <v-btn
                                                class="ml-2 mr-1"
                                                @click="() => rollbackInfo()"
                                                small
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                @click="updateInfo"
                                                small
                                                color="success"
                                            >
                                                save
                                            </v-btn>
                                        </v-layout>
                                    </div>
                                </v-layout>
                            </v-card-actions>
                        </v-layout>
                        <v-spacer></v-spacer>

                        <v-layout
                            align-end
                            justify-space-between
                            column
                            fill-height
                            class="mb-2 mr-4"
                        >
                            <!-- <v-card
                                raised
                                class="note-box mr-2 mb-2 elevation-0"
                            >
                                <div
                                    class=""
                                    style="background-color: rgb(92, 184, 96); color: #fff;"
                                >
                                    <v-layout row justify-space-between>
                                        <div
                                            class="font-weight-medium subheading pt-2 pb-2 px-4"
                                        >
                                            Note
                                        </div>
                                        <v-btn
                                            v-if="!editingNote"
                                            @click="() => editNote()"
                                            flat
                                            icon
                                            class="text-xs-right my-0 mr-2"
                                            color="#fff"
                                        >
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </div>
                                <div
                                    v-if="!editingNote"
                                    class="pa-2 mt-2 pt-3"
                                    style="border: rgb(92, 184, 96) 1px solid; border-top: none; min-height: 38px;"
                                >
                                    {{ info.note }}
                                </div>
                                <div
                                    class="pa-2 mt-2 pt-3"
                                    v-if="editingNote"
                                    style="border: rgb(92, 184, 96) 1px solid; border-top: none;"
                                >
                                    <v-textarea
                                        outline
                                        class="mb-3"
                                        hide-details
                                        label="Note"
                                        v-model="info.note"
                                    ></v-textarea>
                                    <v-card-actions class="mb-0 mr-1">
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            dark
                                            color="default"
                                            class="ml-2 mr-1"
                                            @click="() => rollbackNote()"
                                            small
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                            @click="updateInfo"
                                            small
                                            color="success"
                                        >
                                            save
                                        </v-btn>
                                    </v-card-actions>
                                </div>
                            </v-card> -->
                            <v-layout row class="mb-0 mr-0">
                                <v-menu offset-y left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            class="mt-3 mb-2 mr-1"
                                            color="success"
                                            small
                                            dark
                                            v-on="on"
                                        >
                                            Email Cards & Documents
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-tile
                                            v-for="(action,
                                            index) in getPrintCardActions()"
                                            :key="index"
                                            @click="emailCards(action.type)"
                                            :disabled="action.isDisabled"
                                        >
                                            <v-list-tile-title>{{
                                                action.text +
                                                    (action.isDisabled
                                                        ? " - " +
                                                          action.disabledMessage
                                                        : "")
                                            }}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                                <v-menu offset-y left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            class="mt-3 mb-2 mr-1"
                                            color="success"
                                            small
                                            dark
                                            v-on="on"
                                        >
                                            Download Cards & Documents
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-tile
                                            :disabled="action.isDisabled"
                                            v-for="(action,
                                            index) in getPrintCardActions()"
                                            :key="index"
                                            @click="printCards(action.type)"
                                        >
                                            <v-list-tile-title>{{
                                                action.text +
                                                    (action.isDisabled
                                                        ? " - " +
                                                          action.disabledMessage
                                                        : "")
                                            }}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                                <v-btn
                                    class="mt-3 mb-2 mr-2"
                                    color="info"
                                    small
                                    @click="newStudentDialog = true"
                                    >New Student</v-btn
                                >
                            </v-layout>
                        </v-layout>
                    </v-layout>
                </v-card>
                <transactions-list
                    :transactions="transactions"
                    :documents="documents"
                    :account="account"
                    :girlsCampAccount="girlsCampAccount"
                    :refresh="load"
                    :regID="regID"
                    :currentRegID="currentRegID"
                    :country="getCountry()"
                    :openDialogForStudent="openDialogForStudent"
                    :openPaymentModal="openPaymentModal"
                    :printStatement="printStatement"
                    :openEmailStatementDialog="openEmailStatementDialog"
                    :openNewCreditCardModal="openNewCreditCardModal"
                    :loading="transactionsLoading"
                ></transactions-list>
            </v-flex>
            <v-flex xs4 class="pa-0">
                <balance-details
                    :loading="transactionsLoading"
                    :regID="regID"
                    :total="girlsCampAccount.debit"
                    :previousBalance="girlsCampAccount.previousBalance"
                    :paid="girlsCampAccount.paid"
                    :scheduledPayments="girlsCampAccount.scheduledPayments"
                    :totalPaid="girlsCampAccount.totalPaid"
                    :balance="girlsCampAccount.balance"
                    :pastYearsEnrollmentInfo="pastYearsEnrollmentInfo"
                    :account="girlsCampAccount"
                ></balance-details>

                <payment-methods
                    :reloadPage="load"
                    :paymentMethods="paymentMethods"
                >
                </payment-methods>

                <notes
                    v-if="notesUrl"
                    :loadUrl="notesUrl"
                    :accountID="account.accountID"
                    :typeID="regID"
                    type="GIRLSCAMP"
                ></notes>

                <card-logs
                    :loading="cardLogsLoading"
                    :cardLogs="cardLogs"
                ></card-logs>
            </v-flex>
        </v-layout>

        <v-dialog v-model="newPaymentMethodDialog" max-width="400">
            <new-payment-method
                :accountID="account.accountID"
                :closeDialog="closeNewPaymentMethodDialog"
                :onSave="load"
                :hideBankAccount="true"
            ></new-payment-method>
        </v-dialog>

        <v-dialog persistent scrollable v-model="paymentDialog" max-width="800">
            <payment
                :paymentMethods="paymentMethods"
                :closePaymentDialog="closePaymentModal"
                :account="account"
                :girlsCampAccount="girlsCampAccount"
                :refresh="load"
            ></payment>
        </v-dialog>
        <v-dialog persistent v-model="newStudentDialog" max-width="400">
            <new-student
                :onCreated="onNewStudentCreated"
                :closeNewStudentModal="closeNewStudentModal"
                :account="account"
                :gradesSetup="gradesSetup"
                :refresh="load"
            ></new-student>
        </v-dialog>
        <v-dialog persistent v-model="newAccountDialog" max-width="800">
            <new-account
                ref="newAccount"
                :closeNewAccountModal="closeNewAccountModal"
                :onCreated="onNewAccountCreated"
            ></new-account>
        </v-dialog>
        <v-dialog v-model="emailStatementDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Email Statement</v-card-title>
                <v-text-field
                    class="px-3"
                    v-model="emailAddress"
                    :rules="emailRules"
                    ref="emailStatement"
                ></v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="emailStatementDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="emailing"
                        color="success"
                        @click="emailStatement"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="printCardsDialog" max-width="400">
            <v-card class="pa-2">
                <div v-if="studentsMissingImmunizationsDocuments().length">
                    <v-card-title class="text-danger headline"
                        >Missing Immunizations</v-card-title
                    >
                    <v-card-text class="mb-2">
                        Immunizations Documents are Missing for:
                        <br />
                        {{
                            getStudentNames(
                                studentsMissingImmunizationsDocuments()
                            )
                        }}
                    </v-card-text>
                </div>
                <div v-else>
                    <v-card-title class="text-warning headline"
                        >Are you sure?</v-card-title
                    >
                    <v-card-text class="mb-2">
                        Lunch Documents are Missing for:
                        <br />
                        {{ getStudentNames(studentsMissingLunchDocuments()) }}
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="printCardsDialog = false">Cancel</v-btn>
                        <v-btn color="success" @click="print">
                            Print
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="emailCardsDialog" max-width="400">
            <v-card class="pa-2">
                <!-- <div v-if="studentsMissingImmunizationsDocuments().length">
                    <v-card-title class="text-danger headline"
                        >Missing Immunizations</v-card-title
                    >
                    <v-card-text class="mb-2">
                        Immunizations Documents are Missing for:
                        <br />
                        {{
                            getStudentNames(
                                studentsMissingImmunizationsDocuments()
                            )
                        }}
                    </v-card-text>
                </div>
                <div v-else>
                    <div v-if="studentsMissingLunchDocuments().length">
                        <v-card-title class="text-warning headline"
                            >Are you sure?</v-card-title
                        >
                        <v-card-text class="mb-2">
                            Lunch Documents are Missing for:
                            <br />
                            {{
                                getStudentNames(studentsMissingLunchDocuments())
                            }}
                        </v-card-text>
                    </div> -->
                <div>
                    <v-card-title class="headline"
                        >Email Cards & Documents</v-card-title
                    >
                </div>
                <v-text-field
                    class="px-3"
                    ref="email"
                    v-model="emailAddress"
                    :rules="emailRules"
                ></v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="emailCardsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="emailing"
                        color="success"
                        @click="sendEmail"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import moment from "moment";
import { loadOptions } from "../../utils/smLookup.js";
import transactionsComponent from "./components/Transactions.vue";
import payment from "./components/Payment.vue";
import schedulePayment from "./components/SchedulePayment.vue";
import newStudent from "./components/newStudent.vue";
import newAccount from "./components/newAccount.vue";
import balanceDetails from "./components/BalanceDetails.vue";
import cardLogs from "./components/CardLogs.vue";
import { getDomain, onlyUnique } from "../../utils/helpers.js";
import newPaymentMethod from "../Payment/NewPaymentMethod.vue";
import paymentMethods from "../Account/PaymentMethods.vue";
import notes from "../components/Notes.vue";

export default {
    components: {
        balanceDetails,
        paymentMethods,
        cardLogs,
        notes,
        payment: payment,
        "schedule-payment": schedulePayment,
        "transactions-list": transactionsComponent,
        "new-account": newAccount,
        "new-student": newStudent,
        newPaymentMethod,
    },
    data() {
        return {
            account: {},
            girlsCampAccount: {},

            transactions: [],
            classes: [],
            students: [],
            enrolledStudents: [],
            gradesSetup: [],
            pastYearsEnrollmentInfo: [],

            paymentMethods: [],
            documents: [],

            paymentDialog: false,
            newStudentDialog: false,
            newAccountDialog: false,

            transactionsLoading: true,
            cardLogsLoading: true,

            info: "",
            countries: [],
            originalInfo: "",
            editingInfo: false,
            editingNote: false,
            customInfo: "",
            openDialogForStudent: null,
            printCardsDialog: false,
            newPaymentMethodDialog: false,
            cardTypeToEmail: "",

            emailCardsDialog: false,
            emailStatementDialog: false,
            emailAddress: "",
            emailing: false,

            regID: "",
            currentRegID: "",

            countryRules: [(value) => !!value || "Required."],
            emailRules: [
                (value) => !!value || "Required.",
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            ],

            customCountryRules: [(value) => !!value || "Required."],

            transportationList: [],
            cardLogs: [],

            notesUrl: "",
        };
    },
    async created() {
        this.load();
    },
    computed: {},
    methods: {
        async load() {
            await this.loadRegID();
            await this.loadAccount();
            await this.loadGirlsCampAccount();
            await this.loadGradesSetup();
            await this.loadClasses();
            await this.loadStudets();
            await this.loadTransctions();
            await this.loadCountries();
            await this.loadDocuments();
            await this.loadClickedStudent();
            await this.loadTranspotationList();
            await this.loadCardLogs();

            this.loadSavedCards();
        },
        async loadRegID() {
            const regID = "GC2020";

            this.currentRegID = regID;

            this.regID = this.currentRegID;

            this.notesUrl =
                "api/girlsCamp/getNotes?accountID=" +
                this.$route.params.id +
                "&regID=" +
                this.regID;
        },
        async loadAccount() {
            this.account = await this.$http.get(
                "api/accounts/GetAccount?accountID=" + this.$route.params.id
            );

            this.emailAddress = this.account.emailAddress;
        },
        async loadGirlsCampAccount() {
            this.girlsCampAccount = await this.$http.get(
                "api/girlsCamp/getAccount?accountID=" + this.$route.params.id
            );

            this.info = await this.$http.get(
                "api/girlsCamp/GetGirlsCampAccountInfo?accountID=" +
                    this.$route.params.id +
                    "&regID=" +
                    this.regID
            );
        },
        async loadClasses() {
            const classes = await this.$http.get(
                "api/classSetup/get?regID=" + this.regID
            );
            this.classes = classes;
        },
        async loadTransctions() {
            const response = await this.$http.get(
                "api/girlsCamp/GetTransactions?accountID=" +
                    this.$route.params.id +
                    "&regID=" +
                    this.regID
            );

            const transactions = response.map((t) => {
                t.date = t.date;
                t.dateCreated = t.dateCreated ? t.dateCreated : null;
                t.lastUpdated = t.lastUpdated ? t.lastUpdated : null;

                return t;
            });

            this.enrolledStudents = await this.$http.get(
                "api/lapidusDayCamp/GetEnrolledStudents?accountID=" +
                    this.$route.params.id +
                    "&regID=" +
                    this.regID
            );

            const printedCards = await this.$http.get(
                "api/lapidusDayCamp/GetPrintedCards?accountID=" +
                    this.$route.params.id +
                    "&regID=" +
                    this.regID
            );

            const bills = transactions
                .filter((t) => t.txnType == "D")
                .map((transaction) => {
                    const enrollment = this.enrolledStudents.find(
                        (s) => s.id == transaction.dayCampID
                    );

                    const student = this.students.find(
                        (s) => s.studentID == enrollment.studentID
                    );

                    transaction.student = {
                        isEnrolled: true,
                        originalDuration: enrollment.regType,
                        total: transaction.amount,
                        enrollment: enrollment,
                        cardPrinted: enrollment.cardPrintDate,
                        bunkCardPrinted: enrollment.bunkCardPrintDate,
                        busCardPrinted: enrollment.busCardPrintDate,
                        studentID: student.studentID,
                        school: student.school,
                        teacherName: student.teacherName,
                        teacherNumber: student.teacherNumber,
                        section: student.section,
                        nonUTA: student.nonUTA,
                        name: student.engName,
                        engName: student.engName,
                        dob: student.dob,
                        studentID: student.studentID,
                        hebName: student.hebName,
                        class: student.class,
                        chosenClass: this.getClass(enrollment),
                        chosenBunk: this.getBunk(enrollment),
                    };

                    return transaction;
                });

            const credits = transactions.filter((t) => t.txnType == "C");

            this.transactions = bills.concat(credits);

            this.transactionsLoading = false;

            const payments = await this.$http.get(
                "api/girlsCamp/GetPayments?accountID=" + this.$route.params.id
            );

            this.transactions.forEach((transaction) => {
                if (transaction.paymentLogID || transaction.scheduleDetailID) {
                    transaction.payment = this.getPayment(
                        payments,
                        transaction
                    );
                }
            });
        },
        getPayment(payments, transaction) {
            if (transaction.paymentLogID) {
                return payments.find(
                    (p) => p.paymentID == transaction.paymentLogID
                );
            }

            let payment = payments.find(
                (p) =>
                    p.scheduleDetailId == transaction.scheduleDetailID &&
                    p.status == "PROCESSED"
            );

            return payment
                ? payment
                : payments.find(
                      (p) => p.scheduleDetailId == transaction.scheduleDetailID
                  );
        },
        getClass(student) {
            if (student.classID == null) return "";

            return this.classes.find((c) => c.classID == student.classID);
        },
        getBunk(student) {
            if (student.bunkID == null) return "";

            return this.classes.find((c) => c.classID == student.bunkID);
        },
        async loadStudets() {
            const students = await this.$http.get(
                `api/lapidusDayCamp/getStudents?linkId=${
                    this.account.accountLinkID
                }&pin=${this.account.pinNum}`
            );

            this.students = students;
        },
        async loadGradesSetup() {
            this.gradesSetup = await this.$http.get(
                "api/lapidusDayCamp/getGradesSetup"
            );
        },
        hasDayCamp(student) {
            return this.gradesSetup.find((g) => g.grade == student.class)
                .isCountryAvail;
        },
        getStudentNames(students) {
            return students
                .map((t) => t.student.name)
                .filter(onlyUnique)
                .join(", ");
        },
        async loadCardHistory() {
            // this.cardHistory = await this.$http.get(
            //     "api/lapidusDayCamp/getCardHistory?accountID=" +
            //         this.account.accountID
            // );
        },
        async loadCardLogs() {
            const cardLogs = await this.$http.get(
                "api/girlsCamp/getCardLogs?accountID=" + this.account.accountID
            );

            this.cardLogsLoading = false;
            this.cardLogs = cardLogs;
        },
        async loadSavedCards() {
            const paymentMethods = await this.$http.get(
                "api/payments/getSavedCards?accountID=" + this.account.accountID
            );

            this.paymentMethods = paymentMethods
                .filter((p) => p.type == "CC")
                .map((method) => {
                    method.cardInfo =
                        (method.cardType ? method.cardType : "") +
                        " - " +
                        method.cardNumberLast5;

                    method.editing = false;
                    method.processing = false;

                    return method;
                })
                .sort((a, b) => {
                    if (Date.parse(a.lastUsed) > Date.parse(b.lastUsed))
                        return -1;
                    if (Date.parse(a.lastUsed) < Date.parse(b.lastUsed))
                        return 1;
                    return 0;
                });
        },
        async loadCountries() {
            this.countries = await loadOptions("country");
        },
        async loadTranspotationList() {
            const list = await this.$http.get(
                "api/girlsCamp/getTranspotationList"
            );

            this.transportationList = list.filter(Boolean);
        },
        async loadDocuments() {
            if (!this.account.nonUTA) {
            }

            this.documents = (await this.$http.get(
                "api/girlsCamp/GetDocuments?accountID=" + this.account.accountID
            )).map((documentDetail) => {
                documentDetail.uploadedOn = moment(
                    documentDetail.uploadedOn
                ).format("LLL");

                return documentDetail;
            });
        },
        async loadClickedStudent() {
            if (!this.$route.query.studentID) return;

            const enrollment = this.enrolledStudents.find(
                (s) => s.studentID == this.$route.query.studentID
            );

            const student = this.students.find(
                (s) => s.studentID == this.$route.query.studentID
            );

            this.openDialogForStudent = {
                isEnrolled: true,
                enrollment: enrollment,
                studentID: student.studentID,
                nonUTA: student.nonUTA,
                name: student.engName,
                engName: student.engName,
                dob: student.dob,
                studentID: student.studentID,
                hebName: student.hebName,
                class: student.class,
                chosenClass: this.getClass(enrollment),
                chosenBunk: this.getBunk(enrollment),
            };
        },
        getCountry() {
            if (!this.info) return "";

            return "";
        },
        editNote() {
            this.originalNote = this.info.note;
            this.editingNote = true;
        },
        rollbackNote() {
            this.info.note = this.originalNote;
            this.editingNote = false;
        },
        editInfo() {
            this.originalNote = this.info.note;
            this.originalTransportation = this.info.transportation;
            this.editingInfo = true;
        },
        rollbackInfo() {
            this.info.note = this.originalNote;
            this.info.transportation = this.originalTransportation;
            this.editingInfo = false;
        },
        async updateInfo() {
            try {
                await this.$http.post("api/girlsCamp/updateAccountInfo", {
                    familyID: this.account.accountID,
                    note: this.info.note,
                    transportation: this.info.transportation,
                    regID: this.regID,
                });
            } catch (e) {
                this.$notify({
                    text: "An error has occurred",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            this.editingInfo = false;
            this.editingNote = false;

            this.load();
        },
        getLogType(log) {
            switch (log.type) {
                case "GC_CARDS":
                case "GC_CARDS2":
                    return "Bus & Bunk Cards";
                case "GC_BUS":
                    return "Bus Cards";
                case "GC_BUNK":
                    return "Bunk Cards";
                case "GC_RULES":
                    return "תקנות בויגן";
                case "GC_FORM":
                    return "Health & Lunch Form";
                default:
                    return "Registration Cards";
            }
        },
        openPaymentModal() {
            this.paymentDialog = true;
        },
        closePaymentModal() {
            this.paymentDialog = false;
        },
        onNewStudentCreated() {
            this.newStudentDialog = false;

            this.load();
        },
        closeNewStudentModal() {
            this.newStudentDialog = false;
        },
        closeNewAccountModal() {
            this.newAccountDialog = false;
        },
        async editAccount() {
            const newAccountPrefill = await this.$http.get(
                "api/lapidusDayCamp/getNewAccount?accountID=" +
                    this.account.accountID
            );

            this.$refs.newAccount.prefill(newAccountPrefill);

            this.newAccountDialog = true;
        },
        onNewAccountCreated(account) {
            this.load();
        },
        getPrintCardActions() {
            const actions = [
                {
                    text: "Registration Card",
                    type: "GIRLSCAMP",
                    disabledMessage: false,
                    isDisabled: false,
                },
                {
                    text: "Health & Lunch Form",
                    type: "GC_FORM",
                    disabledMessage: false,
                    isDisabled: false,
                },
                {
                    text: "תקנות בויגן",
                    type: "GC_RULES",
                    disabledMessage: false,
                    isDisabled: false,
                },
                {
                    text: "Bus & Bunk Cards",
                    type: "GC_CARDS",
                    isDisabled:
                        !this.info.transportation ||
                        !this.transactions.some(
                            (t) => t.student && t.student.chosenBunk
                        ),
                    disabledMessage: this.getCardsDisabledMessage(),
                },
                {
                    text: "Bus & Bunk Cards Blank",
                    type: "GC_CARDS2",
                    isDisabled:
                        !this.info.transportation ||
                        !this.transactions.some(
                            (t) => t.student && t.student.chosenBunk
                        ),
                    disabledMessage: this.getCardsDisabledMessage(),
                },
            ];

            return actions;
        },
        getCardsDisabledMessage() {
            let message = "N. A. ";

            if (!this.info.transportation) {
                message += "Missing Transportation ";
            }

            if (
                !this.transactions.some(
                    (t) => t.student && t.student.chosenBunk
                )
            ) {
                message += "Missing Assigned Bunk";
            }

            return message;
        },
        printCards(type) {
            // if (
            //     this.studentsMissingLunchDocuments().length ||
            //     this.studentsMissingImmunizationsDocuments().length
            // ) {
            //     return (this.printCardsDialog = true);
            // }

            this.print(type);
        },
        studentsMissingLunchDocuments() {
            return this.transactions.filter(
                (transaction) =>
                    transaction.txnType == "D" &&
                    !transaction.student.enrollment.lunchDoc
            );
        },
        studentsMissingImmunizationsDocuments() {
            const nonUtaStudents = this.transactions.filter(
                (transaction) =>
                    transaction.txnType == "D" && transaction.student.nonUTA
            );

            return nonUtaStudents.filter(
                (t) =>
                    !this.documents
                        .map((d) => d.studentID)
                        .includes(t.student.studentID.trim())
            );
        },
        print(type = "GIRLSCAMP") {
            window.location =
                getDomain() +
                "/api/girlsCamp/downloadCards?accountID=" +
                this.account.accountID +
                "&docType=" +
                type +
                "&user=" +
                this.$store.state.authentication.user;

            this.printCardsDialog = false;

            this.load();
        },
        emailCards(type = "GIRLSCAMP") {
            this.cardTypeToEmail = type;

            this.emailCardsDialog = true;
        },
        async sendEmail() {
            if (!this.$refs.email.validate()) return;

            this.emailing = true;

            await this.$http.post(
                "api/girlsCamp/emailCards?accountID=" +
                    this.account.accountID +
                    "&emailAddress=" +
                    this.emailAddress +
                    "&docType=" +
                    this.cardTypeToEmail +
                    "&user=" +
                    this.$store.state.authentication.user
            );

            this.$notify({
                text: "Email Sent",
                group: "notification",
                type: "success",
            });

            this.emailing = false;

            this.emailCardsDialog = false;
            this.emailAddress = this.account.emailAddress;

            this.load();
        },
        getRegisteredWeeks(transaction) {
            const weeks = Object.keys(transaction.student.enrollment)
                .map((key) => {
                    if (
                        !key.startsWith("week") ||
                        !transaction.student.enrollment[key]
                    )
                        return;

                    return key.substring(4);
                })
                .filter(Boolean);

            return weeks.join(", ");
        },
        closeNewPaymentMethodDialog() {
            this.newPaymentMethodDialog = false;
        },
        updateSelectedPaymentMethod(paymentMethod) {
            paymentMethod.cardInfo =
                paymentMethod.cardType + " - " + paymentMethod.cardNumberLast5;

            this.paymentMethods.push(paymentMethod);
        },
        createStatement() {
            let html = `<!DOCTYPE html>
            <html>
            <head>
            <style>
                table {
                  font-family: arial, sans-serif;
                  border-collapse: collapse;
                  width: 100%;
                }

                td, th {
                  border: 1px solid #dddddd;
                  text-align: left;
                  padding: 8px;
                }
                .text-table td, table {
                    border: none;
                    padding: 0px;
                    background-color: #fff;
                }

                .account-info {
                    font-family: arial, sans-serif;
                    text-align: left;
                    font-weight: 200;
                    margin-bottom: 20px;
                }

                tr:nth-child(even) {
                  background-color: #dddddd;
                }
                .regular-text {
                    margin-bottom: 8px;
                    margin-top: 0px;
                }
            </style>
            </head>
            <body style="padding: 10px;">

            <p class="regular-text" style="text-align: center;"><span style="font-size: 13pt;">
            <strong><span style="font-family: arial, helvetica, sans-serif;">MACHNA TALMUDIS SATMAR</span>
            </strong></span></p>
            <p class="regular-text" style="text-align: center;"><span style="font-size: 13pt;">
            <strong><span style="font-family: arial, helvetica, sans-serif;">מחנה תלמידות דסאטמאר</span>
            </strong></span></p>
            <p class="regular-text" style="text-align: center;"><span style="font-size: 11pt;">
            <span style="font-family: arial, helvetica, sans-serif;">— פענסילוועניע —</span></span></p>
            <p>&nbsp;</p>

            <div class="account-info">
            <p class="regular-text"><strong>${this.account.name}</strong></p>
            <p class="regular-text"><strong>Address: </strong>${
                this.account.address1
            }</p>
            <p class="regular-text"><strong>Phone: </strong>${
                this.account.homePhone
            }</p>`;

            if (this.account.emailAddress) {
                html += `<p class="regular-text"><strong>Email: </strong>${
                    this.account.emailAddress
                }</p>`;
            }

            html += `
            </div>

            <table style="border-collapse: collapse; width: 100%;" border="1">
            <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Charges</th>
                <th>Payments</th>
            </tr>
            <tbody>`;

            const transactions = JSON.parse(JSON.stringify(this.transactions));

            transactions.forEach((transaction) => {
                html += `<tr>
                    <td>${moment(transaction.date).format("L")}</td>
                    <td>${this.getTransactionDescription(transaction)}</td>
                    <td><strong>${
                        transaction.txnType == "D"
                            ? transaction.calcAmount
                            : "0"
                    }</strong></td>
                    <td><strong>${
                        transaction.txnType == "C"
                            ? transaction.calcAmount
                            : "0"
                    }</strong></td>
                </tr>`;
            });

            html += `</tbody></table>
                <p>&nbsp;</p>
                <table class="text-table" style="width: 30%; margin-right: 10px;" align="right">
                <tr>
                <td><p class="regular-text">Billed:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.girlsCampAccount.debit
                    }</strong></p></td>
                </tr>
                <td><p class="regular-text">Paid:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.girlsCampAccount.totalPaid
                    }</strong></p></td>
                </tr>
                <td><p class="regular-text">Total Balance:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.girlsCampAccount.balance
                    }</strong></p></td>
                </tr>
                </table>

                </body>
            </html>`;

            return html;
        },
        getTransactionDescription(transaction) {
            let description =
                transaction.txnType == "D"
                    ? (transaction.student ? transaction.student.engName : "") +
                      " - " +
                      transaction.description
                    : transaction.description;

            if (
                transaction.txnType == "D" &&
                transaction.student &&
                transaction.student.enrollment.regType == "CUSTOM"
            ) {
                description +=
                    " Weeks: " + this.getRegisteredWeeks(transaction);
            } else if (
                transaction.payment &&
                transaction.payment.cardNumLast5
            ) {
                description +=
                    " " +
                    (transaction.payment.cardType
                        ? transaction.payment.cardType + " - "
                        : " - ") +
                    transaction.payment.cardNumLast5;
            }

            return description;
        },
        printStatement() {
            const newWindow = window.open(
                "",
                "Account Statement",
                "width=800, height=800"
            );

            newWindow.document.write(this.createStatement());
        },
        openEmailStatementDialog() {
            this.emailStatementDialog = true;
        },
        openNewCreditCardModal() {
            this.newPaymentMethodDialog = true;
        },
        async emailStatement() {
            if (!this.$refs.emailStatement.validate(true)) return;

            this.emailing = true;

            try {
                await this.$http.post("api/girlsCamp/emailLetter", {
                    emailAddress: this.emailAddress,
                    html: this.createStatement(),
                    subject: "Girls Camp Statement",
                });

                this.$notify({
                    text: "Email Sent",
                    group: "notification",
                    type: "success",
                });

                this.emailStatementDialog = false;
            } catch (e) {
            } finally {
                this.emailing = false;
            }
        },
        isBigScreenSize() {
            return window.innerWidth > 1400;
        },
    },
};
</script>
<style>
.note-box {
    border: 1px solid rgb(92, 184, 96);
    width: 342px;
}
</style>
